import React, {useContext, useState, useMemo, useEffect} from 'react';
import {KEYS, CONDITIONS} from '../../utils/Constants';
import {getData, storeData} from '../../utils/GeneralStorage';
import {fetchApi} from '../../utils/ApiHelper';
import {HTTP_METHODS, SUBMIT_EMP_ID} from '../../utils/URLConstants';
import {loadingPauseContext} from '../../contexts/LoadingPauseContext';
import {errorStatusContext} from '../../contexts/ErrorStatusContext';
import {trimSpace} from '../../utils/HelperMethods';
import UI from './ui';
import {Platform} from 'react-native';
import {hasFeatureEnabled, FEATURE_LEVEL} from '../../utils/FeatureConstants';

const SubmitEmployerId = ({navigation, ...props}) => {
  //storeData(KEYS.employerUniqueId, '0'); //Un-comment to get rid of the popup block

  const [inputId, setInputId] = useState('');
  const [inputError, setInputError] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const lpc = useContext(loadingPauseContext);
  const esc = useContext(errorStatusContext);

  useEffect(() => {
    checkAttempts(); //her checkAttempts is invoked without the runFunction argument
  }, []);

  const hasrequestUniqueIdFeatureEnabled = useMemo(() => {
    return hasFeatureEnabled(FEATURE_LEVEL.requestUniqueEmployerId);
  }, []);

  const checkAttempts = runFunction => {
    //this function checks attempts and then runs a function if supplied
    getData(KEYS.numAttemptKey) //logic for making the modal appear/disappear
      .then(numAttempts => {
        if (numAttempts >= CONDITIONS.numAttemptsAllowed) {
          getData(KEYS.blockedTimeKey).then(blockedTime => {
            let timeDiff = new Date() - Date.parse(blockedTime);
            if (CONDITIONS.timeDiffAllowed < timeDiff) {
              storeData(KEYS.numAttemptKey, '0');
            } else {
              setModalVisible(true);
            }
          });
        } else {
          if (runFunction) {
            runFunction();
          }
        }
      });
  };

  const updateNumAttempts = () => {
    setInputError(true);
    getData(KEYS.numAttemptKey).then(numAttempts => {
      numAttempts ? numAttempts++ : (numAttempts = 1);
      if (numAttempts == CONDITIONS.numAttemptsAllowed) {
        //set the blocker time once
        storeData(KEYS.blockedTimeKey, new Date().toString());
      }
      storeData(KEYS.numAttemptKey, '' + numAttempts);
    });
  };

  const checkEmployerId = () => {
    //will also disable the button once we have that functionality in button NRTK8CEU
    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.GET, SUBMIT_EMP_ID(trimSpace(inputId)))
      .then(response => response.data)
      .then(data => {
        lpc.setVisible(false);
        if (data.status == 'success') {
          storeData(KEYS.numAttemptKey, '0');
          storeData(KEYS.employerUniqueId, inputId).then(() => {
            if (Platform.OS === 'web') {
              // forwarding to provide details step
              props?.moveToNextStep(2);
            } else {
              navigation.navigate('AccountDetailsScreen');
            }
          });
        } else {
          updateNumAttempts();
        }
      })
      .catch(error => {
        lpc.setVisible(false);
        //possibly save in analytics too
        updateNumAttempts();
        esc.showError(error);
      });
  };

  const uiProps = {
    navigation,
    setInputError,
    setInputId,
    inputError,
    checkAttempts,
    inputId,
    setModalVisible,
    modalVisible,
    checkEmployerId,
    hasrequestUniqueIdFeatureEnabled,
    ...props,
  };

  return <UI {...uiProps} />;
};

export default SubmitEmployerId;
